export function reorderBlocks(blocks, fromIndex, toIndex) {
	if (fromIndex === toIndex) return blocks;
	const next = [...blocks];
	const [item] = next.splice(fromIndex, 1);
	next.splice(toIndex, 0, item);
	return next;
}

export function resolveDropIndex(clientY, itemRects) {
	if (!itemRects.length) return 0;

	for (let i = 0; i < itemRects.length; i += 1) {
		const rect = itemRects[i];
		const mid = rect.top + rect.height / 2;
		if (clientY < mid) {
			return i;
		}
	}

	return itemRects.length;
}

/** 将 UI 插入索引转为 splice 后的实际插入位置 */
export function resolveReorderToIndex(fromIndex, insertIndex) {
	if (fromIndex === insertIndex) return fromIndex;
	if (fromIndex < insertIndex) {
		return insertIndex - 1;
	}
	return insertIndex;
}
